"use client";
import * as React from "react";

export function Box5() {
  return (
    <section className="relative px-6 sm:px-10 py-24">
      <div className="flex gap-16 items-center max-w-[1344px] mx-auto w-full max-md:flex-col max-md:gap-12">
        {/* Image Section */}
        <div className="w-[400px] h-[400px] max-md:w-[300px] max-md:h-[300px]">
          <img
            src="Group71.png"
            alt="Mission illustration"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Text Section */}
        <div className="flex flex-col flex-1 gap-6">
          <h2 className="text-5xl font-bold text-white leading-[56px] max-sm:text-4xl max-sm:leading-10 font-fredoka">
            Staking Program{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
              – Starts During Presale
            </span>
          </h2>

          <p className="text-2xl leading-8 text-neutral-100 max-sm:text-lg max-sm:leading-7">
            We believe in rewarding our earliest supporters right from the
            beginning. That’s why staking begins immediately when the presale
            launches — no need to wait until TGE!
          </p>
        </div>
      </div>
    </section>
  );
}
